import { Paper, styled } from "@mui/material"

import {
    BORDER_RADIUS,
    PADDING_BASE_MULTIPLIER,
} from "../../themes/defaultThemeParams"
/**
 * Styled paper component for use across App. Should be used over generic
 * material UI paper component.
 */
const AppPaper = styled(Paper)(({ theme }) => ({
    padding: theme.spacing(PADDING_BASE_MULTIPLIER),
    borderRadius: theme.shape.borderRadius * BORDER_RADIUS,
    boxShadow: theme.shadows[0],
    backgroundColor: theme.palette.background.frameBackground,
    backgroundImage: "none",
}))

export default AppPaper
